import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useMemo, useState, useContext, createContext } from 'react';
import { usePersistedState } from '@rexlabs/react-hooks';
import { noop } from 'lodash';
var NavigationContext = /*#__PURE__*/createContext({
  activeItem: null,
  isExpanded: true,
  isVisible: false,
  setActiveItem: noop,
  setIsExpanded: noop,
  setIsVisible: noop
});
var Provider = NavigationContext.Provider;
export function NavigationProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  var _usePersistedState = usePersistedState('mainNav.expanded', false),
      _usePersistedState2 = _slicedToArray(_usePersistedState, 2),
      isExpanded = _usePersistedState2[0],
      setIsExpanded = _usePersistedState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisible = _useState4[0],
      setIsVisible = _useState4[1];

  var value = useMemo(function () {
    return {
      activeItem: activeItem,
      isExpanded: isExpanded,
      isVisible: isVisible,
      setActiveItem: setActiveItem,
      setIsExpanded: setIsExpanded,
      setIsVisible: setIsVisible
    };
  }, [activeItem, isExpanded, isVisible, setIsExpanded, setActiveItem, setIsVisible]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children);
}
export function useNavigation() {
  return useContext(NavigationContext);
}